import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { AgendaPage } from 'src/modules/calendar/components/pages/agenda.page';
import { calendarSearchSchema } from 'src/modules/shared/schemas/calendar.schema';

export const Route = createFileRoute('/calendar/')({
  component: CalendarLayoutComponent,
  validateSearch: (search) => calendarSearchSchema.parse(search),
});

function CalendarLayoutComponent() {
  return (
    <AuthenticateRoute>
      <AgendaPage />
    </AuthenticateRoute>
  );
}
